<sona-organization-switcher />
@if (user()) {
    <button id="user-menu-toggle"
            class="after:tw-content-none"
            hlmBtn
            [brnMenuTriggerFor]="menu"
            align="end"
            variant="ghost"
            [size]="isMobile() ? 'icon' : 'default'"
            [attr.aria-label]="'AUTH.FEATURE_USER_MENU.ACTION.USER_MENU' | translate">
        <sona-icon name="dots-three-outline-vertical" appearance="fill" size="small"></sona-icon>
    </button>
    <ng-template #menu>
        <hlm-menu>
            <!-- User Actions -->
            <ng-container *ngTemplateOutlet="content" />
            @if (_usageFacade.isTrialing()) {
                <button hlmMenuItem sonaEndTrialButton></button>
            }

            <button hlmMenuItem sonaLanguageMenu (onLanguageUpdate)="updateUserLang($event)">
                <div class="tw-mr-auto">
                    {{ 'AUTH.FEATURE_USER_MENU.ACTION.LANGUAGE' | translate }}
                </div>
                <hlm-menu-item-sub-indicator />
            </button>

            <a hlmMenuItem [routerLink]="['/onboarding']">
                <div class="tw-mr-auto">
                    {{ 'AUTH.FEATURE_USER_MENU.ACTION.ONBOARDING' | translate }}
                </div>
            </a>

            @if (_authFacade.isOrganizationOwner()) {
                <a hlmMenuItem [routerLink]="['/organization']">
                    {{ 'AUTH.FEATURE_USER_MENU.ACTION.ORGANIZATION_SETTINGS.LABEL' | translate }}
                </a>
            } @else {
                <div [hlmTooltipTrigger]="'AUTH.FEATURE_USER_MENU.ACTION.ORGANIZATION_SETTINGS.DISABLED_TOOLTIP' | translate">
                    <button hlmMenuItem disabled>
                        {{ 'AUTH.FEATURE_USER_MENU.ACTION.ORGANIZATION_SETTINGS.LABEL' | translate }}
                    </button>
                </div>
            }

            <hlm-menu-separator />

            <a hlmMenuItem [href]="featurebaseUrl()" target="_blank" [attr.aria-disabled]="!featurebaseUrl()">
                <div class="tw-mr-auto">
                    Community
                </div>
                <sona-icon class="tw-ml-4 tw-text-muted-foreground" name="arrow-up-right" size="tiny" />
            </a>

            <hlm-menu-separator />

            <button hlmMenuItem class="tw-text-destructive" (click)="signOut()">
                {{ 'AUTH.FEATURE_USER_MENU.ACTION.SIGN_OUT' | translate }}
            </button>
        </hlm-menu>
    </ng-template>
} @else {
    <div class="tw-flex tw-gap-2">
        <button hlmBtn variant="ghost" sonaLanguageMenu></button>
        <a hlmBtn routerLink="/auth">
            {{ 'AUTH.FEATURE_USER_MENU.ACTION.SIGN_IN' | translate }}
        </a>
    </div>
}

<ng-template #content>
    <ng-content />
</ng-template>